import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useSessionManager } from '../hooks/useSessionManager';

/**
 * SessionProvider Component
 * Wraps children with session management functionality.
 * Tracks user activity and refreshes session automatically.
 */
export const SessionProvider = ({ children }) => {
  const { user, logout } = useAuth();
  const isAuthenticated = !!user;
  
  // Initialize session manager
  useSessionManager(isAuthenticated, logout);
  
  return <>{children}</>;
};

export default SessionProvider;
